<template>
  <section class="interest-point">
    <div class="nav-top">
      <router-link to="/admin/activities" class="arrow-back">
        <img src="@/assets/arrow-orange.svg">
        <p>Voltar</p>
      </router-link>
      <elvas-button :button="{title: 'publicar'}"></elvas-button>
    </div>
    <div v-if="activity">
      <h4 class="admin-medium-bold-text">Ponto de Interesse</h4>
      <p class="id">ID: {{id}}</p>
      <h5 class="admin-small-bold-text-brown">Images</h5>
      <p class="admin-small-text-brown">Adicionar até 3 imagens</p>
      <section class="interest-point-images">
        <div class="image" v-for="(image, key) in activity.images" :key="image" >
          <label :for="'image-' + key">
            <img :src="image.image_url">
          </label>
          <input type="file" :id="'image-' + key" hidden @change="e => uploadImage(e, image.description)">
        </div>
      </section>
      <section class="data">
        <section>
          <div>
            <p class="admin-small-bold-text-brown">Nome</p>
            <div><input placeholder="Nome em Português (PT)" v-model="translations.find(t => t.language === 'pt').name"></div>
            <div class="div-input-margin"><input placeholder="Nome em Inglês (EN)" v-model="translations.find(t => t.language === 'en').name"></div>
            <div class="div-input-margin"><input placeholder="Nome em Espanhol (ES)" v-model="translations.find(t => t.language === 'es').name"></div>
          </div>
          <div>
          </div>
        </section>
        <section>
          <div>
            <p class="admin-small-bold-text-brown">Descrição</p>
            <div><textarea placeholder="Descrição em Português (PT)" v-model="translations.find(t => t.language === 'pt').description"></textarea></div>
            <div class="div-input-margin"><textarea placeholder="Descrição em Inglês (EN)" v-model="translations.find(t => t.language === 'en').description"></textarea></div>
            <div class="div-input-margin"><textarea placeholder="Descrição em Espanhol (ES)" v-model="translations.find(t => t.language === 'es').description"></textarea></div>
          </div>
        </section>
      </section>
    </div>
    <elvas-button class="delete-button" v-if="activity && $route.params.id !== 'new'" :button="{title: 'eliminar'}" @click.native="deleteActivity()"></elvas-button>
  </section>
</template>
<script>

export default {
  name: 'adminActivity',
  components: {
  },
  props: [],
  data() {
    return {
      activity: null,
      translations: [
        {
          language: 'pt'
        },
        {
          language: 'en'
        },
        {
          language: 'es'
        }
      ]
    }
  },
  async mounted () {
    if (this.$route.params.id !== 'new') {
      this.id = this.$route.params.id
      this.activity = await this.api.get('activity/' + this.$route.params.id)
      this.translations.forEach(t => {
        let activityTranslation = this.activity.translations.find(it => it.language === t.language)
        if (activityTranslation) {
          t.name = activityTranslation.name
          t.description = activityTranslation.description
          t.exists = true
        }
      })
    } else {
      this.activity = {}
    }
  },
  methods: {
    availableLanguages () {
      return ['En', 'Es']
    },
    async saveInterestPoint (activity) {
      let response = await this.api.put('/activity/' + activity.id, activity) 

    },
    async saveActivity () {
      let response
      if (this.$route.params.id !== 'new') {
        response = await this.api.put('/activity/' + this.activity.id, this.activity)
      } else {
        response = await this.api.post('/activity', this.activity)
        this.activity = response.data
      }
      this.translations.forEach(t => {
        if (t.exists) {
          this.saveActivityTranslation(t)
        } else {
          this.addActivityTranslation(t)
        }
      })

    },
    async saveActivityTranslation (activityTranslation) {
      let response = await this.api.put('/activityTranslation/' + this.activity.id + '/language/' + activityTranslation.language, activityTranslation) 

    },
    async addActivityTranslation () {
      let response = await this.api.post('/activityTranslation', {...this.newTranslation, interest_point_id: this.activity.id}) 
      this.activity.translations.push(response)
    },
    async uploadImage (e, description) {
      let data = new FormData()
      data.append('image', e.target.files[0])
      data.append('content_id', this.calendarItem.id)
      data.append('description', description)

      let response = await this.api.post('/image', data)
    },
    async deleteActivity () {
      await this.api.delete('/activity/' + this.activity.id)
      this.$router.push('..')
    }
  }
}
</script>
<style lang="scss" scoped>
.interest-point {
  width: 100%;
  padding: 16px 128px 100px 128px;
  flex-grow: 1;
  background: #fff;

  @media (max-width: 1000px){
    padding: 16px 56px 100px 56px;
    width: calc(100% - 300px);
  }

  @media (max-width: 550px){
    padding: 16px 12px 100px 12px;
    width: calc(100% - 100px);
  }
}
.nav-top {
  display: flex;
  align-items: center;
  margin-bottom: 50px;
}
.arrow-back {
  display: flex;
  align-items: center;
  img {
    transform: rotateY(180deg);
  }
  p {
    margin-left: 12px;
    font-size: 14px;
    font-weight: 800;
    line-height: 1;
    letter-spacing: 1px;
    color: #f6b92f;
    text-transform: uppercase;
  }

  @media (max-width: 550px){
    img {
      width: 16px;
      height: 16px;
    }
  }
}
.elvas-button {
  margin-left: auto;

  @media (max-width: 550px){
    padding: 16px 28px;
  }
}
.interest-point-images {
  display: flex;
  width: 100%;
  margin-top: 16px;
  .image {
    width: calc(100% / 3 - 20px);
    img {
      width: 100%;
    }
    &:nth-of-type(2) {
      margin: 0 30px;
    }
  }

  @media (max-width: 1000px){
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;

    .image {
      width: 100%;

      &:nth-of-type(2) {
        margin: 0;
      }
    }
  }

  @media (max-width: 700px){
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;

    .image {
      width: 100%
    }
  }
}
input, textarea {
  padding: 12px 16px;
  border: 1px solid#f6ede0;
  width: calc(100% - 32px);
  &:active, &:focus {
    outline: 1px solid #f6b92f;
  }
}
textarea {
  min-height: 88px;
}
h4 {
  margin-bottom: 5px;
}
h5 {
  margin-bottom: 10px;
}
.id {
  margin-bottom: 32px;
}
.admin-small-bold-text-brown {
  margin-bottom: 16px;
}
.base-interest-point-information, .translation-interior {
  margin-left: 20px;
  margin-right: 60px;
  & > section {
    display: flex;
    width: 100%;
    & > div {
      margin-right: 40px;
      flex-grow: 1;
      margin-bottom: 10px;
      input, textarea {
        width: 100%;
        padding: 5px;
        margin: 5px 0 20px 0;
      }
      textarea {
        min-height: 60px;
        margin: 25px 0 20px 0;
        &:first-of-type {
          margin-top: 0;
        }
      }
    }
  }
}
.data {
  section {
    width: 100%;
    display: flex;
    margin-top: 32px;
    div {
      flex-grow: 1;
    }
    & > div:nth-of-type(2) {
      padding-left: 30px;
    }
  }

  @media (max-width: 800px){
    section {
      flex-direction: column;

      & > div:nth-of-type(2) {
        padding-left: 0;
        margin-top: 32px;
      }
    }
  }
}
.div-input-margin {
  margin-top: 16px;
}
.translations {
  h5 {
    margin-left: 20px;
  }
  .translation-container, .new-translation-container {
    .language {
      display: flex;
      margin: 10px 0;
      margin-left: 20px;
      .language-name {
        margin-left: 10px;
        font-weight: bold;
      }
      select {
        margin-left: 10px;
      }
    }
  }
  .translation-container {
    margin-left: 20px;
  }
}
</style>